module.exports = __webpack_public_path__ + "assets/img/温广平-code.ec4d9c6d.jpg";